import axios from "axios";
import CryptoJS from "crypto-js";
const { VUE_APP_SHIELD_URL, VUE_APP_CRYPT } = process.env;

function encryptForURL(data) {
    const encrypted = CryptoJS.AES.encrypt(data.toString(), VUE_APP_CRYPT).toString();
    return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); 
}

export default class pdfService {

    static async pdfAwsBucket(poliza, sponsor, redirect, token, year) {
        try 
            {       
            // console.log(poliza, sponsor, redirect, token);
            const encryptedPoliza = encryptForURL(poliza);
            // console.log(encryptedPoliza, sponsor, redirect, token);

            // Llamada al controlador shield
            const PdfRes = await axios.get(
            `${VUE_APP_SHIELD_URL}/soapRefactor/getAmazonia/${encryptedPoliza}/${sponsor}/${redirect}/${year}`,
            {
                mode: 'cors',
                headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'x-captcha-authorization': token,
                }
              }
            )
            // console.log( PdfRes.data.data.data);
            const base64 = PdfRes?.data?.data?.data;
            if (!base64) {
                throw new Error('not found in bucket');
            }

            return {
            status: PdfRes.data.status,
            fileFinal: `data:application/pdf;base64,${base64}`,
            };

        } catch (error) {
            const statusCode = error?.response?.status;

            const shouldFallback =
            statusCode === 500 ||
            statusCode === 404 ||
            error.message === 'not found in bucket';

            if (shouldFallback) {
            try {
                const PdfRes2 = await axios.get(
                `${VUE_APP_SHIELD_URL}/soapRefactor/getLastYearPdf?polizaNumber=${poliza}&sponsor=${sponsor}&redirect=${redirect}&year=${year}`,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'x-captcha-authorization': token,
                    },
                }
                );

                if (!PdfRes2?.data?.data) {
                return {
                    status: 'error',
                    message: 'PDF no encontrado db',
                };
                }

                return {
                status: PdfRes2.data.status,
                fileFinal: `data:application/pdf;base64,${PdfRes2.data.data}`,
                };

            } catch (fallbackError) {
                //console.log('Fallback error:', fallbackError.message);
                return {
                status: 'error',
                message: 'Falló bucket y fallback db',
                };
            }
        }
        // console.log('Bucket error:', error.message);
        return {
        status: 'error',
        message: 'Error al obtener PDF desde S3',
            };
        }
    }

    static async pdfAws(poliza, sponsor, redirect, token, year) {
        try {
            //Llamada al controlador pdfMake de Vaulperk
            const PdfRes = await axios.get(
                `${VUE_APP_SHIELD_URL}/soapRefactor/getLastYearPdf?polizaNumber=${poliza}&sponsor=${sponsor}&redirect=${redirect}&year=${year}`,
                {
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        "x-captcha-authorization": token,
                    }
                }
            )

            // console.log(PdfRes.data.data);

            let fileFinal = "data:application/pdf;base64," + PdfRes.data.data;
            //Crear PDF
            let finalObject = {
                status: PdfRes.data.status,
                fileFinal: fileFinal
            }
            // let decodedBase64 = base64.base64Decode(PdfRes.data.data, 'public/PolizaGenerada.pdf');

            // console.log(decodedBase64)

            return finalObject;
        } catch (error) {
            console.log(error.message);
            return {
                status: "error",
                message: "Ocurrio un error al obtener encontrar el Id",
            };
        }
    }
}
